import React from 'react'

const authRoute = [
    {
        key: 'signIn',
        path: `/sign-in`,
        component: React.lazy(() => import('features/auth/pages/LoginPage')),
        authority: [],
    },
    {
        key: 'signUp',
        path: `/sign-up`,
        component: React.lazy(() => import('features/auth/pages/RegisterPage')),
        authority: [],
    },
    {
        key: 'forgotPassword',
        path: `/forgot-password`,
        component: React.lazy(() =>
            import('features/auth/pages/ForgotPasswordPage')
        ),
        authority: [],
    },
    {
        key: 'resetPassword',
        path: `/reset-password`,
        component: React.lazy(() =>
            import('features/auth/pages/ResetPasswordPage')
        ),
        authority: [],
    },
    // Post-login legal entity selection screen (Requirement 2.10).
    // Mounted on the public side because the user is not yet fully
    // signed in (`signedIn = false` while entity selection is pending),
    // so ProtectedRoute would otherwise redirect them back to /sign-in.
    {
        key: 'selectEntity',
        path: `/select-entity`,
        component: React.lazy(() =>
            import('features/auth/pages/SelectEntityPage')
        ),
        authority: [],
    },
]

export default authRoute
